import React from "react";

import useServiceData from "../../../utility/useServiceData";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesigntwo";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesigntwo";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";

const DoctorOnCall = () => {
  const serviceUrl = window.location.href;
  const data = useServiceData("Doctor on Call");
  const imageUrl = data?.image_url;
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      subheading: "Common questions about our Doctor on Call services in Dubai",
    },
    {
      question: "How quickly can I get a doctor to my location?",
      answer:
        "Most Doctor on Call services in Dubai offer quick response times, with doctors often arriving within 1-2 hours of your request.",
    },
    {
      question: "Can I get a prescription during a Doctor at Home visit?",
      answer:
        "Yes, if the doctor determines you need medication, they will issue a prescription, and in some cases may even deliver the medication to your location.",
    },
    {
      question: "Is Doctor on Call suitable for emergencies?",
      answer:
        "No, for life-threatening emergencies such as chest pain, difficulty breathing, or severe injuries, you should go to the nearest hospital or call an ambulance.",
    },
    {
      question: "Can children use Doctor on Call services?",
      answer:
        "Absolutely! This service is great for parents who want to avoid the hassle of taking their sick children to a clinic or hospital.",
    },
  ];

  const doctorAtHomeSteps = [
    { heading: "How Does Doctor at Home Service Work?" },
    {
      para: "Our Doctor at Home service begins with a straightforward booking process, followed by a personalized in-home consultation.",
    },
    {
      title: "Booking",
      description:
        "Schedule an appointment through a simple call or online booking. Our team will work with you to arrange a convenient time that fits your schedule.",
      icon: "fa-solid fa-calendar-check", // Calendar/booking related icon
    },
    {
      title: "Consultation",
      description:
        "Our experienced doctor arrives at your location equipped to address your healthcare needs, carrying any required equipment for accurate diagnosis and treatment.",
      icon: "fa-solid fa-user-doctor", // Doctor consultation icon
    },
    {
      title: "Personalized Care Plan",
      description:
        "During the visit, the doctor will conduct a thorough assessment and develop a customized care plan to address specific health issues and concerns.",
      icon: "fa-solid fa-file-medical", // Medical file / care plan icon
    },
    {
      title: "Follow-up",
      description:
        "Depending on your health needs, follow-up visits or remote monitoring may be recommended to ensure optimal recovery and health maintenance.",
      icon: "fa-solid fa-notes-medical", // Follow-up/health notes icon
    },
  ];

  const benefitsOfDoctorOnCall = [
    { heading: "Benefits of Doctor on Call in Dubai" },
    {
      para: "The Doctor on Call in Dubai is designed to cater to both urgent and non-urgent medical needs. Here are some of the key advantages",
    },
    {
      title: "Convenience",
      description:
        "Skip the waiting rooms and traffic by having the doctor come to you, at a time that suits your schedule.",
      icon: "fa-solid fa-clock", // Example: FontAwesome clock icon
    },
    {
      title: "Personalized Care",
      description:
        "Receive one-on-one attention in the comfort of your home, office, or hotel, ensuring a more personalized approach to your health needs.",
      icon: "fa-solid fa-user-md", // Example: FontAwesome doctor icon
    },
    {
      title: "Flexibility",
      description:
        "Ideal for elderly patients, those with mobility issues, or individuals who need immediate medical assistance.",
      icon: "fa-solid fa-handshake", // Example: FontAwesome handshake icon
    },
    {
      title: "Privacy",
      description:
        "All consultations take place in your chosen private space, ensuring your medical concerns remain confidential.",
      icon: "fa-solid fa-user-shield", // Example: FontAwesome privacy/security icon
    },
  ];

  return (
    <>
      <title>
        Doctor on Call in Dubai | Doctor at Home Service Near Me in Dubai
      </title>
      <meta
        name="description"
        content="Doctor on Call in Dubai - Get a doctor on call in Dubai for fast, reliable medical care at your doorstep. Expert DHA-certified, multilingual doctors available 24/7 for consultations, treatments, and emergency support. Call now."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/doctor-on-call-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Doctor on Call in Dubai | Doctor at Home Service Near Me in Dubai"
      />
      <meta
        property="og:description"
        content="Doctor on Call in Dubai - Get a doctor on call in Dubai for fast, reliable medical care at your doorstep. Expert DHA-certified, multilingual doctors available 24/7 for consultations, treatments, and emergency support. Call now."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/doctor-on-call-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-01-06T09:44:06+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-82.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-82.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Doctor on Call" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Doctor on Call in Dubai | Doctor at Home Service Near Me in Dubai"
      />
      <meta
        name="twitter:description"
        content="Doctor on Call in Dubai - Get a doctor on call in Dubai for fast, reliable medical care at your doorstep. Expert DHA-certified, multilingual doctors available 24/7 for consultations, treatments, and emergency support. Call now."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-82.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <section className="overflow-hidden ">
          <div className="position-relative mb-3">
            <img
              src={imageUrl}
              alt="doctor on call dubai"
              className="img-fluid w-100 rounded mt-2 "
              style={{
                height: "500px",
                objectFit: "cover",
                objectPosition: "top",
                border: "2px solid #c69933",
                borderRadius: "100px",
              }}
            />
          </div>
        </section>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Doctor on call
                </li>
              </ol>
            </nav>
            <div className="container">
              <h1
                className="display-4 fw-semibold"
                style={{
                  color: "#c69933",
                }}
              >
                Doctor on Call Dubai
              </h1>
            </div>
            <QuickNavigation />
            <div className="container  text-center">
              <h3 className="display-5 fw-semibold">
                <span>Expert Care, Right at Your </span>
                <span>Doorstep</span>
              </h3>
            </div>
            <div>
              <p>
                At Elite Body Home, we bring world-className healthcare directly
                to your doorstep with our Doctor on Call service. Whether it’s a
                medical consultation, urgent care, or routine check-up, our team
                of experienced, DHA-certified doctors is available to provide
                personalized treatment and care in the comfort of your home,
                hotel, or workplace. No more long waits or hospital visits – our
                compassionate professionals ensure your well-being is
                prioritized, offering the highest level of medical expertise at
                your convenience. With Elite Body Home, premium healthcare is
                just a call away.
              </p>
            </div>
            <div className="container my-5">
              <h3 className="text-center mb-5 fw-bold title">
                Contact Information
              </h3>

              <div className="row text-center g-4">
                {/* Call Us */}
                <div className="col-md-4">
                  <div className="p-4 border rounded shadow-sm h-100">
                    <div className="mb-3">
                      <i className="fas fa-phone fa-2x text-primary"></i>
                    </div>
                    <h5 className="fw-semibold">Call Us</h5>
                    <p className="text-muted mb-0">
                      Book an appointment at <br /> +971 55 120 0086 anytime.
                    </p>
                  </div>
                </div>

                {/* Availability */}
                <div className="col-md-4">
                  <div className="p-4 border rounded shadow-sm h-100">
                    <div className="mb-3">
                      <i className="far fa-calendar-check fa-2x text-success"></i>
                    </div>
                    <h5 className="fw-semibold">Availability</h5>
                    <p className="text-muted mb-0">
                      Available round the clock, 365 days a year.
                    </p>
                  </div>
                </div>

                {/* Response Time */}
                <div className="col-md-4">
                  <div className="p-4 border rounded shadow-sm h-100">
                    <div className="mb-3">
                      <i className="fas fa-user-clock fa-2x text-warning"></i>
                    </div>
                    <h5 className="fw-semibold">Response Time</h5>
                    <p className="text-muted mb-0">
                      Reach you within 30–45 minutes.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <section class="container py-5">
              <div class="text-center mb-4">
                <h2 class="fw-bold title">
                  Meet Our Home Visit Doctors in Dubai
                </h2>
                <p class="lead">
                  Health emergencies or routine check-ups shouldn’t disrupt your
                  comfort or schedule. At Elite Body Home, we redefine
                  convenience by delivering expert medical care directly to you.
                </p>
                <p class="lead">
                  Our dedicated team of DHA-licensed doctors offers urgent care,
                  routine consultations, and 24/7 availability wherever you are
                  in Dubai — home, hotel, or office.
                </p>
              </div>

              <div class="text-center mb-5">
                <h3 class="fw-semibold">What Sets Our Doctors Apart?</h3>
              </div>

              <div class="row text-center g-4">
                <div class="col-md-4">
                  <div class="p-4 border rounded">
                    <i class="bi bi-award fs-1 text-primary mb-3"></i>
                    <h5>Certified Experts</h5>
                    <p>
                      Every doctor is DHA-licensed, ensuring you receive trusted
                      and professional care.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="p-4 border rounded">
                    <i class="bi bi-clipboard-check fs-1 text-success mb-3"></i>
                    <h5>Comprehensive Care</h5>
                    <p>
                      From routine check-ups to urgent medical attention, our
                      doctors are equipped to handle it all.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="p-4 border rounded">
                    <i class="bi bi-translate fs-1 text-warning mb-3"></i>
                    <h5>Multilingual Communication</h5>
                    <p>
                      Our team speaks multiple languages, bridging gaps in
                      communication for Dubai's diverse population.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="p-4 border rounded">
                    <i class="bi bi-heart fs-1 text-danger mb-3"></i>
                    <h5>Patient-Centered Approach</h5>
                    <p>
                      Compassionate and understanding, our doctors prioritize
                      your comfort and well-being.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="p-4 border rounded">
                    <i class="bi bi-clock-history fs-1 text-info mb-3"></i>
                    <h5>Prompt and Convenient</h5>
                    <p>
                      Available 365 days, ensuring fast response times and
                      flexible visits to your home, hotel, or workplace.
                    </p>
                  </div>
                </div>
              </div>

              <div class="text-center my-5">
                <p class="lead">
                  Looking for a doctor on call near you? Choose Elite Body Home
                  for premium, personalized healthcare wherever you are in
                  Dubai.
                </p>
              </div>
            </section>

            <section className="container py-5">
              <div className="text-center mb-4">
                <h2 className="fw-semibold title">
                  What Our Doctor at Home Service Covers
                </h2>
                <p className="text-muted mt-3">
                  Explore our comprehensive Doctor at Home services and book an
                  appointment at your convenience. Our treatments cover:
                </p>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      Strains, sprains, back pain &amp; joint relief.
                    </li>
                    <li className="list-group-item">
                      Heartburn, queasiness &amp; nausea relief.
                    </li>
                    <li className="list-group-item">
                      Small cuts, bruises &amp; wound management.
                    </li>
                    <li className="list-group-item">
                      Minor fractures &amp; accident care.
                    </li>
                    <li className="list-group-item">
                      Sinus infections, sore throats, ear issues &amp;
                      nosebleeds.
                    </li>
                    <li className="list-group-item">
                      Cold, flu, fever, allergies &amp; food sensitivities.
                    </li>
                    <li className="list-group-item">
                      Skin concerns, nail infections &amp; rashes.
                    </li>
                    <li className="list-group-item">
                      Cough, congestion &amp; fatigue support.
                    </li>
                    <li className="list-group-item">
                      Blood pressure &amp; diabetes management.
                    </li>
                    <li className="list-group-item">
                      HIV/STD/STI &amp; urinary tract infection. <br />
                      Headaches, migraines,
                    </li>
                    <li className="list-group-item">
                      Dizziness &amp; sleep issues.
                    </li>
                    <li className="list-group-item">
                      Abdominal pain, constipation &amp; digestive wellness.
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <div id="procedures">
              <CardDesign carditems={doctorAtHomeSteps} />
            </div>
            <div id="benefits">
              <ListDesign listitems={benefitsOfDoctorOnCall} />
            </div>
            <WhyUs language="en" />
            <FAQAccordion faqData={faqData} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default DoctorOnCall;
